import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["modal", "title", "preview", "downloadLink"]

  connect() {
    this.modalTarget.addEventListener("click", (e) => {
      if (e.target === this.modalTarget) {
        this.close()
      }
    })
  }

  open(event) {
    const button = event.currentTarget
    const url = button.dataset.documentUrl
    const name = button.dataset.documentName
    const type = button.dataset.documentType

    this.titleTarget.textContent = name
    this.downloadLinkTarget.href = url

    this.previewTarget.innerHTML = ""

    if (type && type.includes("image")) {
      const img = document.createElement("img")
      img.src = url
      img.alt = name
      this.previewTarget.appendChild(img)
    } else if (type && type.includes("pdf")) {
      const iframe = document.createElement("iframe")
      iframe.src = url
      this.previewTarget.appendChild(iframe)
    } else {
      this.previewTarget.innerHTML = `
        <div class="document-preview-placeholder">
          <svg width="64" height="64" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
            <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/>
            <polyline points="14 2 14 8 20 8"/>
            <line x1="16" y1="13" x2="8" y2="13"/>
            <line x1="16" y1="17" x2="8" y2="17"/>
            <polyline points="10 9 9 9 8 9"/>
          </svg>
          <p>Preview not available for this file type</p>
          <p class="text-sm text-subtle">Click download to view</p>
        </div>
      `
    }

    this.modalTarget.showModal()
  }

  close() {
    this.modalTarget.close()
  }
}
